<template>
  <div class="goods">
   <v-head @meetingType="meetingStatusMed"></v-head>
   <div class="banner" >
   	 <img class="banner_img" src="../../assets/images/meeting_banner.jpg" alt />
   	<div class="fonts">
   		<h3>{{(meetingDetail.name)}}</h3>
   		<p>时间：{{formatDateYMD(meetingDetail.startDate)}}--{{formatDateYMD(meetingDetail.endDate)}}</p>
   		<p>地点：{{(meetingDetail.provinceName)}}{{(meetingDetail.cityName)}}{{meetingDetail.address}}</p>
   	</div> 
   </div> 
   <div class="box">
  	 <h3>拟参会代表请登录学会会议服务系统<br/>在线注册报名</h3>
  	 <div class="boxfonts">
  	 	<p>会议报名：{{formatDateYMD(meetingDetail.registerStartDate)}}-
      {{formatDateYMD(meetingDetail.registerEndDate)}}</p>
  	 	<p>缴纳会费：{{formatDateYMD(meetingDetail.payStartDate)}}-
      {{formatDateYMD(meetingDetail.payEndDate)}}</p>
  	 	<p>论文投稿：{{formatDateYMD(meetingDetail.deliveryStartDate)}}-
      {{formatDateYMD(meetingDetail.deliveryEndDate)}}</p>
  	 	<!-- <p>酒店预订：2019年9月20日-9月24日</p> -->
  	 </div>
   </div>
    <div class="loginBox">
      <van-row>
        <van-col span="8" >
          <div class="boxT" @click="goRegist">
           <span><img src="../../assets/images/xiaoren.png"></span>
           <h4>登录注册</h4> 
          </div>
        </van-col>
        <van-col span="8">
          <div class="boxT"  @click="goRegist">
           <span><img src="../../assets/images/sign.png"></span>
           <h4>会议报名</h4> 
          </div>
        </van-col>
        <van-col span="8">
          <div class="boxT" @click="createOrder">
           <span><img src="../../assets/images/jiaofei-xianxing.png"></span>
           <h4>缴纳会费</h4> 
          </div>
        </van-col>
      </van-row>
<!--       <div class="loginCont">
        <van-icon name="play" />
        <div class="buttOn">
          <van-button type="primary">会员登录</van-button>
          <van-button type="primary" style=" background: #8290a3; border-color: #8290a3">立即注册</van-button>
        </div>
      </div> -->
    </div>


   <div class="introduction" v-show="meetingStatus.meetingInfoStatus">
    <img src="../../assets/images/bg_1.png" class="img1">
     <h4>
       <p class="bg1">大会简介</p>
       <p class="bg2">GENERAL INTRODUCTION</p>
     </h4>
     <div class="intrCont" v-html="meetingAffairDetail.meetingInfo"></div>
     <img src="../../assets/images/bg_2.png" class="img2">
   </div>
   
   <div class="schedule" v-show="meetingStatus.scheduleStatus">
      <!-- 大会日程 -->
      <section v-if="meetingAffairDetail.schedule" class="paper_container">

        <div class="title2">
          <div>大会日程</div>
        </div>
        <div
          class="schedulea"
          v-html="meetingAffairDetail.schedule ? meetingAffairDetail.schedule.replace('<table', '<table border=1') : ''"
        />
      </section>
   </div>

      <div class="schedule" v-show="meetingStatus.reportInfoStatus">
          <!-- 会议报告 -->
          <section v-if="meetingAffairDetail.reportInfo" class="paper_container">

              <div class="title2">
                  <div>会议报告</div>
              </div>
              <div
                      class="schedulea"
                      v-html="meetingAffairDetail.reportInfo"
              />
          </section>
      </div>
      <div class="schedule" v-show="meetingStatus.contactUsStatus">
          <!-- 联系我们 -->
          <section v-if="meetingAffairDetail.contactUs" class="paper_container">
              <div class="title2">
                  <div>联系我们</div>
              </div>
              <div
                      class="schedulea"
                      v-html="meetingAffairDetail.contactUs"
              />
          </section>
      </div>
      <div class="schedule" v-show="meetingStatus.contactUsStatus">
          <!-- 联系我们 -->
          <section v-if="meetingAffairDetail.contactUs" class="paper_container">
              <div class="title2">
                  <div>联系我们</div>
              </div>
              <div
                      class="schedulea"
                      v-html="meetingAffairDetail.contactUs"
              />
          </section>
      </div>

  </div>
</template>

<script>
import { getMeetingDetail,getCurrentAccount ,getBase64,getRegisterList,createMeetingOrder} from "@/api/dictionary";
import { NavBar,Icon,Row, Col,DropdownMenu,DropdownItem,Button,Toast} from 'vant';
import {mapState} from "vuex";
import { getSessionStore } from "../../utils/sessionStorage.js";
import vHead from "../../components/MeetingHeader.vue";
export default {
  data() {
    return {
       meetingAffairDetail: {},
       //会议图片
       meetingPhoto: "../../assets/images/meeting_banner.jpg",
       meetingDetail: {},
       meetingDues:[],
       meetingVisitorRoute:[],
       meetingStatus:{
           scheduleStatus:true,
           reportInfoStatus:true,
           meetingInfoStatus:true,
           contactUsStatus:true,
       },
       account:{},
    };
  },
  components: {
  	vHead,
      [Icon.name]: Icon,
      [Row.name]: Row,
      [Col.name]: Col,
      [Button.name]: Button,
      [Toast.name]: Toast,
  },
    computed:{
      ...mapState(["userInfo"]),
      meetingId(){
          return this.$route.query&&this.$route.query.meetingId;
      }
    },
  methods: {
	  go(pathName) {
	      this.$router.push({ name: pathName });
	  },
    getStatus() {
      let token = getSessionStore("access_token");
      if (token) {
        getCurrentAccount()
          .then(resp => {
            if (resp.success) {
              this.memberId = resp.result.id;
              this.account = resp.result;
              getRegisterForm().then(resp => {
                if (resp.success) {
                  this.registerForm = resp.result;
                }
              });
            }
          })
          .catch(err => {});
      }
      getMeetingDetail({
        meetingId: this.meetingId
      })
        .then(detailResp => {
          if (detailResp.success) {
            let res = detailResp.result;
            this.meetingDetail = res.meetingDTO;
            // if (this.memberId) {
            //   this.getRegisterInfo();
            // }
            if (res.meetingAffairDTO) {
              this.meetingAffairDetail = res.meetingAffairDTO;
                // let reg = new RegExp(/style\s*?=\s*?([‘"])[\s\S]*?\1/, "g");
                // if (this.meetingAffairDetail.meetingInfo){
                //   this.meetingAffairDetail.meetingInfo=
                //   this.meetingAffairDetail.meetingInfo.replace(reg,"");
                // }
                // if (this.meetingAffairDetail.schedule){
                //   this.meetingAffairDetail.schedule=
                //   this.meetingAffairDetail.schedule.replace(reg,"");
                // }
                // if (this.meetingAffairDetail.reportInfo){
                //   this.meetingAffairDetail.reportInfo=
                //   this.meetingAffairDetail.reportInfo.replace(reg,"");
                // }
                // if (this.meetingAffairDetail.contactUs){
                //   this.meetingAffairDetail.contactUs=
                //   this.meetingAffairDetail.contactUs.replace(reg,"");
                // }
            }
            if (res.meetingDTO.photoId != null) {
              this.getPhoto(res.meetingDTO.photoId);
            }
            this.meetingDues = res.meetingDuesDTOs;
            this.meetingPlace = res.meetingPlaceDTOs;
            this.meetingVisitorRoute = res.meetingVisitorRouteDTOs;
            for (var hotel of res.meetingHotelDTOs) {
              hotel.photo = "static/images/meeting/jd_default.png";
              if (hotel.photoId) {
                getBase64({
                  id: hotel.photoId
                }).then(resp => {
                  if (resp.success) {
                    hotel.photo = resp.result;
                  }
                });
              }
            }
            this.meetingHotel = res.meetingHotelDTOs;
          }else {
              Toast.fail("获取会议详细信息失败！");
          }
        })
    },
    formatDateYMD(timeStamp) {
        let year = new Date(timeStamp).getFullYear();
        let month =new Date(timeStamp).getMonth() + 1 < 10? "0" + (new Date(timeStamp).getMonth() + 1): new Date(timeStamp).getMonth() + 1;
        let date =new Date(timeStamp).getDate() < 10? "0" + new Date(timeStamp).getDate(): new Date(timeStamp).getDate();
        let hh =new Date(timeStamp).getHours() < 10? "0" + new Date(timeStamp).getHours(): new Date(timeStamp).getHours();
        let mm =new Date(timeStamp).getMinutes() < 10? "0" + new Date(timeStamp).getMinutes(): new Date(timeStamp).getMinutes();
        let ss =new Date(timeStamp).getSeconds() < 10? "0" + new Date(timeStamp).getSeconds(): new Date(timeStamp).getSeconds();
        return year + "年" + month + "月" + date + "日";
    },
    getPhoto(photoId) {
        if (!photoId) return;
        getBase64({
            id: photoId
        }).then(resp => {
            if (resp.success) {
                this.meetingPhoto = resp.result;
            }
        });
    },
      getRegisterInfo() {
          getRegisterList({ meetingId: this.meetingId, memberId: this.memberId })
              .then(resp => {
                  if (resp.success && resp.result.length > 0) {
                      var registerInfo = resp.result.filter(
                          itm =>
                              itm.meetingRegister &&
                              itm.meetingRegister.memberId == this.memberId
                      );
                      this.isRegister = registerInfo.length > 0;
                      if (this.isRegister) {
                          this.registerObj = registerInfo[0].meetingRegister;
                          this.isPaper = registerInfo[0].paperFlag;
                          this.isOrder =
                              this.meetingDetail.chargeInSystem &&
                              (registerInfo[0].orderInfo ? true : false); //在系统中缴费
                      }
                  }
              })
              .catch(() => {
                  this.$message.error("获取已报名会议失败！");
              });
      },
      meetingStatusMed(meet){
          for(let key in this.meetingStatus){
              if(key==meet){
                  this.meetingStatus[key] = true;
              }else if(meet=="shouye"){
                  this.meetingStatus[key] = true;
              }else {
                  this.meetingStatus[key] = false;
              }
          }
      },
      createOrder() {
          let params = {
              meetingId: this.meetingId,
              memberId: getSessionStore("memberId")
          };

          createMeetingOrder(params).then(res => {
              if (res.success) {
                  Toast.success("创建成功");
                  this.$router.push({path:"/payMeeting"});
              } else {
                  Toast.fail("创建订单失败");
              }
          });
      },
      goRegist(){
          let member = this.account;
          let meeting = this.meetingDetail;
          let status = false;
          if(meeting.participantsCode&&meeting.participantsIdentity&&meeting.participantsCode.length!=0&&meeting.participantsIdentity.length!=0){
              let participants = meeting.participantsCode.filter(branch=>branch==member.recommendUnitId);
              if(participants.length>0 || meeting.participantsCode[0]=='all'){
                  let club = meeting.participantsIdentity.filter(identity=>identity==member.identity);
                  let branch = meeting.participantsIdentity.filter(identity=>identity==member.branchIdentity);
                  if(club.length==0&&meeting.participantsIdentity[0]!='all'||branch.length==0&&meeting.participantsIdentity[0]!='all'){
                      status = false;
                      Toast.fail("您的职务不能参加本次会议！");
                  }else {
                      status = true;
                  }
              }else {
                  status = false;
                  Toast.fail("本次会议该分会会员不能参加！");
              }
          }else {
              Toast.fail("请设置参会机构与参会身份");
          }
          if(!status){
              this.$router.push({path:"/signUp",query:{"meetingId":this.meetingId}});
          }
      }
	},
    mounted() {
    this.getStatus();
  },
};
</script>

<style lang="less" scoped>
	.banner{ position: relative; }         
	.banner img{ width: 100%; }
	.fonts{ position: absolute; top: 27%; width:96%; color: #fff; padding:2%; text-align:center;}
	.fonts h3{ font-weight: bold;  line-height: 36px; margin-bottom: 20px;}
	.fonts p{ font-size: 14px;  margin-bottom: 20px;}
  .box h3{ font-size: 18px; text-align: center; line-height: 30px; margin-top:25px; }
  .loginBox{ border-bottom: #f3f3f3 solid 8px; padding-bottom: 10px;}
  .box .boxfonts{ font-size: 14px; text-align: center; line-height: 24px; margin-top: 10px; }
  .boxT { font-size:14px; text-align: center; margin-top: 20px; margin-bottom: 10px;}
  .boxT span{ display: block;  margin-bottom: 10px; }
  .boxT span img{ width: 50%; }
  .loginCont .van-icon{color: #f2f3f5; margin-left: 50px;
    transform:rotate(-90deg);
    -ms-transform:rotate(-90deg); /* Internet Explorer */
    -moz-transform:rotate(-90deg); /* Firefox */
    -webkit-transform:rotate(-90deg); /* Safari 和 Chrome */
    -o-transform:rotate(-90deg); /* Opera */}
  .buttOn{ margin-top: -12px; background: #f2f3f5; padding:25px 0; text-align: center;}
  .buttOn /deep/.van-button{ margin: 0 10px; width: 25%; font-size: 16px;}
  .introduction { text-align: center; position: relative; }
  .introduction h4{ font-size:20px; font-weight: bold; text-align: center;width: 85%; display: inline-block;
  height: 60px; position:relative; }
  .introduction h4 .bg1{ position: absolute; top: 25px; text-align: center; width: 100%; z-index: 99}
  .introduction h4 .bg2{ position: absolute;bottom: 5px;  width: 100%; color: #dcdcdc; }
  .introduction .img1{ position: absolute; right: 0; top: 0; width: 40%; z-index: -1 }
  .introduction .img2{ position: absolute; left: 0; bottom: 0; width: 40%; z-index: -1 }
  .intrCont{ font-size:14px; line-height: 24px; text-align: left; padding:0 30px; color: #000; 
    margin-top: 20px;}
  .schedule { font-size:14px; line-height: 24px; text-align: left; padding:0 30px; color: #000; }
  .schedulea table{ width: 100%; text-align: center; }
  .firstRow{background: #eee; }

</style>
